import React from 'react'
import { func, object, bool } from 'prop-types'

import moment from 'moment'

import { Button } from 'react-bootstrap'
import Input from 'coact/Input'


function getColor ({ type, source }) {
  if (type === 'leave') return 'red'
  if (type === 'gate') return source === '輸入' ? 'blue' : 'black'
  if (type === 'overtime') return 'white'
}
function getBackground ({ type, overtimeType }) {
  if (type === 'overtime') {
    if (overtimeType === '一般') return 'orange'
    if (overtimeType === '交通') return 'green'
  }
}

const weekdayTWArr = ['一', '二', '三', '四', '五', '六', '日']
function DateRow (props) {
  const { data, showInput, setShowInput, time, setTime, createGate, delGate, comment, createComment } = props
  const { dateStr, isWorkday, items, note } = data

  const date = moment(dateStr)
  const weekday = date.isoWeekday()
  const weekdayTW = weekdayTWArr[weekday - 1]

  const dateColor = isWorkday ? 'black' : 'red'

  return (
    <div>
      <h4 style={{ display: 'inline-block', color: dateColor }}>
        {dateStr}({weekdayTW})
      </h4>
      <span style={{ display: 'inline-block', minWidth: 300 }}>
        {items.map(({ renderKey, time, type, overtimeType, source, _id }) => {
          const color = getColor({ type, source })
          const background = getBackground({ type, overtimeType })
          const onDoubleClick = type === 'gate'
            ? () => delGate(_id)
            : () => { }

          return (
            <span
              style={{ margin: 10, color, background }}
              key={renderKey}
              onDoubleClick={onDoubleClick}
            >
              {moment(time).format('HH:mm')}
            </span>
          )
        })}
        { note ? (<span>({note})</span>) : null }
      </span>
      <span style={{ margin: 10 }}>
        {
          showInput
            ? (
              <span>
                <Input
                  {...{
                    style: { display: 'inline-block', width: 100 },
                    value: time,
                    onChange: setTime,
                    placeholder: 'HHmm',
                    schema: {
                      type: 'Date',
                      format: 'HH:mm',
                      parseFormat: 'HHmm',
                    },
                  }}
                />
                <Button onClick={createGate}>新增</Button>
                <Button onClick={() => setShowInput(false)}>取消</Button>
              </span>
            )
            : (
              <Button onClick={() => setShowInput(true)}>+</Button>
            )
        }
      </span>
      <span style={{ margin: 10 }}>
        <Input
          {...{
            style: { display: 'inline-block', width: 400 },
            value: comment.comment,
            onChange: (updater) => createComment(updater()),
            placeholder: '輸入備註',
            schema: { type: 'String' },
          }}
        />
      </span>
    </div>
  )
}

DateRow.propTypes = {
  showInput: bool.isRequired,
  setShowInput: func.isRequired,

  time: object,
  setTime: func.isRequired,

  comment: object,
  createComment: func,

  data: object.isRequired,

  delGate: func.isRequired,
  createGate: func.isRequired,
}

export default DateRow



// WEBPACK FOOTER //
// ./src/components/AttendanceChecker/DateRow/DateRow.jsx